import React, { createContext, useContext } from 'react';
import { useAppContext } from '../../../context/AppContext';

const ChatContext = createContext(null);

export function ChatProvider({ children }) {
  const {
    reply, setReply,
    input, setInput,
    isStreaming, setIsStreaming,
    streamingText, setStreamingText,
    chatStatus,
    chatSteps,
    maxInputChars,
    textareaRef,
    replyEndRef,
    abortRef,
    handleSend,
    handleClearChat,
    handleRetry,
    currentSessionId, setCurrentSessionId,
    authToken,
    credits,
    theme,
    // Phase 3 Intelligence Core
    conversationMode,
    completeness,
    opportunities,
    mutationFeedback,
    aiDebugEnabled,
    setAiDebugEnabled,
    pipelineEvents,
    setPipelineEvents,
    latestDebugPayload,
    setLatestDebugPayload,
  } = useAppContext();

  const value = {
    reply,
    setReply,
    input,
    setInput,
    isStreaming,
    setIsStreaming,
    streamingText,
    setStreamingText,
    chatStatus,
    chatSteps,
    maxInputChars,
    textareaRef,
    replyEndRef,
    abortRef,
    handleSend,
    handleClearChat,
    handleRetry,
    currentSessionId,
    setCurrentSessionId,
    authToken,
    credits,
    theme,
    // Phase 3 Intelligence Core
    conversationMode,
    completeness,
    opportunities,
    mutationFeedback,
    aiDebugEnabled,
    setAiDebugEnabled,
    pipelineEvents,
    setPipelineEvents,
    latestDebugPayload,
    setLatestDebugPayload,
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
}

export function useChatContext() {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
}
